import React from "react";
import "./Location.css";

function LocationIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </svg>
  );
}

function ShowroomCard({ title, address, note, mapText = "Xem bản đồ" }) {
  return (
    <div className="showroom-card">
      <h3 className="showroom-card__title">{title}</h3>

      <div className="showroom-card__address">
        <span className="showroom-card__icon showroom-card__icon--blue">
          <LocationIcon />
        </span>
        <p>{address}</p>
      </div>
    </div>
  );
}

export default function Location() {
  return (
    <section className="showroom-section">
      <div className="showroom-container">
        <div className="showroom-heading">
          <h2 className="text-center">
            HỆ THỐNG CÁC SHOWROOM CỦA RUTTIENTHETINDUNGTQ.COM
          </h2>
          <span className="showroom-heading__line"></span>
        </div>

        <div className="showroom-grid">
          <ShowroomCard
            title="SHOWROOM HỒ CHÍ MINH"
            address="Số 01 Lê Minh Nhựt, Ấp Tiền, Xã Tân Thông Hội, Huyện Củ Chi, TP.HCM."
            note="(Từ đầu hẻm 74 đi vào 30m quẹo trái, đi 30m nữa là tới)"
          />
          <ShowroomCard
            title="SHOWROOM HỒ CHÍ MINH"
            address="Số 104 Hòa Bình, Phường Phú Trung, Quận Tân Phú, TP.Hồ Chí Minh."
            note="(Từ đầu hẻm 74 đi vào 30m quẹo trái, đi 30m nữa là tới)"
          />
          <ShowroomCard
            title="SHOWROOM HỒ CHÍ MINH"
            address="Số 184 Võ Văn Ngân, Phường Bình Thọ, Thành phố Thủ Đức."
            note="(Từ đầu hẻm 74 đi vào 30m quẹo trái, đi 30m nữa là tới)"
          />

          <ShowroomCard
            title="SHOWROOM HÀ NỘI"
            address="Số 186 đường Vạn Phúc, Phường Hà Đông, Thành phố Hà Nội."
            note=""
          />
          <ShowroomCard
            title="SHOWROOM HÀ NỘI"
            address="Số 87 đường Tân Xuân, Phường Đông Ngạc, Thành phố Hà Nội."
            note=""
          />
          <ShowroomCard
            title="SHOWROOM HÀ NỘI"
            address="88 Nguyễn Văn Linh, Long Biên,Thành phố Hà Nội."
            note=""
          />
        </div>
      </div>
    </section>
  );
}
